import React from 'react'

const TableSortNoneIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m3 8 4-4 4 4"></path>
            <path d="m11 16-4 4-4-4"></path>
            <path d="M7 4v16"></path>
            <path d="M15 8h6"></path>
            <path d="M15 16h6"></path>
            <path d="M13 12h8"></path>
        </svg>
    )
}

export default TableSortNoneIcon
